import { OverlayContainer } from '@angular/cdk/overlay';
import { Directive, ElementRef } from '@angular/core';

@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[myCdkOverlayContainer]',
  standalone: true,
})
export class CdkOverlayContainerDirective {
  constructor(protected elementReference: ElementRef, protected cdkOverlayContainer: OverlayContainer) {
    this.elementReference = elementReference;
    this.cdkOverlayContainer = cdkOverlayContainer;
    (<any>this.cdkOverlayContainer)['myCreateContainer'](this.elementReference.nativeElement);
  }
}
